<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <ElasticList :list="list"></ElasticList>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  import Page from '@/mixins/Page';

  export default {
    components: {
      ElasticList
    },
    mixins: [Page],
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "productoptions",
          pageTitle: "Product Options",
          pageIcon: "devices",
          linkRows: true,
          listQueryId: "searchProductOptions",
          deleteQueryId: "deleteProductOption",
          columns: {
            name: { label: "Name", sortable: true },
            category: { label: "Category", sortable: true, optionType: "enum" },
            brand: { label: "Brand", sortable: true, optionType: "enum" },
            legacyName: { label: "Legacy Name", sortable: true },
            status: { label: "Status", sortable: false },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchProductOptions && data.searchProductOptions.items.length) {
              data.searchProductOptions.items.forEach((item) => {
                //ATLAS-1740: Output Boolean column value as Active/Inactive
                item.status = (item.status === true) ? 'Active' : 'Inactive';
                result.push(item);
              })
            }
            return result;
          }
        },
      };
    },
  };
</script>

<style></style>
